
import { Animation } from 'animation'
import SlotWinPresenter from 'slot_win_presenter'
import slot_config from 'cfg/slot-config.js'
import { TYPE } from 'network/network_api'
import { Image } from 'utils'

/** Display all lines and scatters win once one by one
 * TODO convert presenter to streams
 */
export function play_wins( space, presenter, global )
{
    space.s('presenter:show_first_time').next(true);

    space.s('presenter:regular_win')
        .map(() => true)
        .to(space.s('presenter:show_first_time'));

    space.s( 'presenter:play_wins' )
        .map( () => -1 )
        .to( space.s( 'presenter:play_next_line' ) )

    const $next_line = space.s( 'presenter:play_next_line' )
        .map( line_order => {
            ++ line_order
            const win_lines = presenter._slotMath.winLines()
            return (line_order < win_lines.length) ? line_order : -1;
        })
    $next_line
        .to( space.s( 'presenter:play_line' ) )
    
    $next_line
        .filter( line_order => line_order < 0 )
        .map( () => true )
        .to( space.s( 'presenter:play_scatters' ) )

    play_line( space, presenter, global )

    play_scatters( space, presenter, global )

    space.s( 'presenter:done_playing_scatters' )
        .map( () => false )
        .to( space.s( 'presenter:play_scatters' ) )
    space.s( 'presenter:done_playing_scatters' ).to( space.s( 'presenter:done_playing_wins' ) )

    space.s( 'presenter:done_playing_wins' )
        .map(() => false)
        .to(space.s('presenter:show_first_time'));
}

export function play_line( space, presenter, global )
{
    let karet
    let t = 0;

    space.s( 'presenter:play_line' )
        .map( line_order => {
            const win_lines = presenter._slotMath.winLines()
            if ( line_order >= 0 )
            {
                karet = 0
                return win_lines[ line_order ]
            }
            return undefined
        } )
        .filter( ln => ln !== undefined )
        //switch to animations ASAP:
        .do( () => space.s( 'presenter:play_line_tick_tock' ).next( 0 ) )
        .name( space, 'presenter:play_line_number' )
        //update symbols asap:
        .on( ln => presenter.showLine( ln ) )
    
    const $playing_line = space.s( 'presenter:playing_line' )

    const gs = global || space
    gs.s( 'ticker' )
        .name( space, 'presenter:play_line_tick_tock' )
        .with( space.s( 'presenter:play_line' ), ( seconds, line_order ) => ({ seconds, line_order }) )
        .filter( ({ line_order }) => line_order >= 0 )
        .map( ({ seconds, line_order }) => ({
            seconds,
            line : presenter._slotMath.winLines()[ line_order ],
            line_order
        }) )
        .filter( ({ line }) => ! isNaN( line ) )
        .map( ({ seconds, line, line_order }) =>
        {
            const line_win_positions = presenter._slotMath.lineWinPositions( line )
            $playing_line.next( {
                line,
                line_win_positions,
                win_symbol : presenter._slotMath.lineWinSymbol( line ),
            } )

            t += seconds
            let done = t > 1.5

            if (t > 0.8) {
                space.s( 'presenter:lines:hide' ).next({line: line});
            }
            if ( done ) {
                //presenter.hideLine( line )
                t = 0;
            }

            return {
                line,
                done,
                line_order
            }
        } )
        .filter( ({ done }) => done )
        .map( ({ line_order }) => line_order )
        .to( space.s( 'presenter:play_next_line' ) )
}

export function play_scatters( space, presenter, global )
{
    let karet
    let playing_scatters

    let t = 0;

    space.s( 'presenter:play_scatters' )
        .filter( playing => playing && presenter._slotMath.scatterWin() <= 0 )
        .to( space.s( 'presenter:done_playing_scatters' ) )

    const gs = ( global || space )
    gs.s( 'ticker' )
        .with( space.s( 'presenter:play_scatters' ), ( seconds, playing ) => ({ seconds, playing }) )
        .filter( ({ playing }) => playing && presenter._slotMath.scatterWin() > 0 )
        .map( ({ seconds }) => {
            if ( ! playing_scatters )
            {
                t = 0;
                playing_scatters = true
            }


            t += seconds
            let done = t > 1.5

            if (t > 0.8) {
                space.s( 'presenter:scatter_hide' ).next();
            }

            if ( done ) {
                playing_scatters = false
                t = 0
            }

            return done
        })
        .filter( done => done )
        .to( space.s( 'presenter:done_playing_scatters' ) )
}


export function regular_game_wins_presentation( space, c, presenter, math )
{
    play_wins( space, presenter || c.slotScene.view.slotPresenter )

    math = math || c.slotScene.view.math || presenter._slotMath
    space.s( 'state' )
        .filter( state => state.state.stage && state.state.stage.math && state.state.stage.math.symbols )
        .map( state => {
            math.spin(
                state.state.stage.math.symbols,
                state.state.line_count,
                state.state.multiplier
            )
            return math
        } )
        .to( space.s( 'math' ) )
    space.s( 'slot:showWin' )
        .with( space.s( 'state' ), space.s( 'math' ), ( _, state ) => state )
        .filter( state => state.type == TYPE.REGULAR )
        .name( space, 'presenter:regular_win' )
        .filter( () => math.winLines().length > 0 || math.scatterWin() > 0 )
        .to( space.s( 'presenter:play_wins' ) )
    
    //cycled up:
    space.s( 'presenter:done_playing_wins' )
        .with( space.s( 'state' ), ( _, state ) => state.type == TYPE.REGULAR )
        .filter( t => t )
        .to( space.s( 'presenter:play_wins' ) )
    
    //interrupts:
    space.s( 'slot:interruptWinShow' )
        .do( () => {
            //hide scatters: (dunno why it's not working by default)
            for ( const s of math.scatterPositions() ) presenter.onSymbolAnimationStart( s ).visible = false
        } )
        .map( () => false )
        .to( space.s( 'presenter:play_scatters' ) )
    space.s( 'slot:interruptWinShow' )
        .map( () => -1 )
        .to( space.s( 'presenter:play_line' ) )

    space.s( 'slot:showWin' )
        .on(() => {
            presenter.startSymbolsAnimation()
        });

}

export function lines_win_display_billets_fix( space, c, presenter ) {
    if ( c ) c.slotScene.view.slotPresenter.showWin = ()=>{}
    presenter = presenter || c.slotScene.view.slotPresenter
    space.s( 'presenter:play_line_number' ).on( ln => {
        for (var i = 0; i < presenter._slotMath.actualLinesNumber(); ++i) {
            presenter.hideActiveBillets(i);
        }
        presenter.showActiveBillets( ln )
    } )
}

export function frames( space, view, spec, slot ) {
    const COUNT = slot.frames_symbol_wise ? spec.specification.symbolsCount : spec.specification.linesPaths.length
    let symbols = []
    for ( let i = 0; i < COUNT; ++ i ) {
        let symbol = []
        symbols[ i ] = symbol
        for ( let j = 0; j < spec.specification.linesPaths.length; ++ j ) {
            const f = Image( slot.frames_template.$( i ) )
            f.visible = false
            view.addChild( f )
            symbol[ j ] = f
        }
    }

    let scatterFrames = [];
    if (slot.scatter_frame) {
        for (let i = 0; i < 5; ++i) {
            let frame = Image(slot.scatter_frame)
            frame.visible = false;
            view.addChild(frame);
            scatterFrames.push(frame);
        }

        space.s( 'presenter:play_scatters' )
            .filter(play => play)
            .with(space.s( 'math' ), (_, math) => math)
            .filter(math => math.scatterWin() > 0)
            .on(math => {

                hide();

                let scatterPos = math.scatterPositions();
                for (let i = 0; i < scatterPos.length; ++i) {
                    let frame = scatterFrames[i];
                    let positionOnBarrel = SlotWinPresenter.symbol_index_to_pos( slot, scatterPos[i] )
                    frame.position.set(
                        SlotWinPresenter.el_x( slot, positionOnBarrel.col ) + ( slot.frames_disp ? slot.frames_disp.x : 0 ),
                        SlotWinPresenter.el_y( slot, positionOnBarrel.row ) + ( slot.frames_disp ? slot.frames_disp.y : 0 ),
                    );
                    frame.visible = true;
                }
            })
    }

    
    function hide() {
        for ( const symbol of symbols ) for ( const f of symbol ) f.visible = false

        if (scatterFrames) {
            scatterFrames.forEach(f => f.visible = false)
        }
    }
    
    space.s( 'presenter:playing_line' ).on( ({ line, line_win_positions, win_symbol }) => {
        hide()
        let i = 0
        for ( const wp of line_win_positions ) {
            const pos = SlotWinPresenter.symbol_index_to_pos( slot, wp )
            const f = symbols[ line ][ i ]
            f.position.set(
                SlotWinPresenter.el_x( slot, pos.col ) + ( slot.frames_disp ? slot.frames_disp.x : 0 ),
                SlotWinPresenter.el_y( slot, pos.row ) + ( slot.frames_disp ? slot.frames_disp.y : 0 ),
            )
            f.visible = true
            ++ i
        }
    } )

    space.s( 'presenter:lines:hide' ).on(hide);
    space.s( 'presenter:scatter_hide' ).on(hide);
    space.s( 'slot:interruptWinShow' ).on( hide )
}




// WEBPACK FOOTER //
// ./src/games/win_presentation.es6